<template>
  <header>
    <div class="lab-header">
      <img
        :src="labLogo"
        alt="实验室logo"
        class="lab-logo"
        @error="setDefaultLogo($event, 'lab')" />
      <div class="lab-title">
        <h1>人工智能和机器人实验室</h1>
        <p>AI and Robotic Systems Lab</p>
      </div>
    </div>

    <div class="sz-header">
      <div class="sz-logos">
        <img
          :src="uestcLogo"
          alt="电子科技大学"
          class="sz-logo"
          @error="setDefaultLogo($event)" />
        <img
          :src="uestcSzLogo"
          alt="电子科技大学（深圳）高等研究院"
          class="sz-logo"
          @error="setDefaultLogo($event)" />
      </div>
      <div class="sz-links">
        <a href="https://uestc.edu.cn" class="sz-link" target="_blank"
          >电子科技大学</a
        >
        <span class="sz-separator">|</span>
        <a href="https://sz.uestc.edu.cn" class="sz-link" target="_blank"
          >电子科技大学（深圳）高等研究院</a
        >
      </div>
      <div class="language-switcher">
        <a href="about.html" class="language-btn active">中文</a>
        <a href="about-en.html" class="language-btn">EN</a>
      </div>
    </div>
  </header>
</template>

<script>
import defaultLogo from "@/assets/1.jpg";
import uestclogo from "@/assets/uestc-logo.png";
import uestszclogo from "@/assets/uestc-sz-logo.png";

export default {
  name: "LabHeader",
  props: {
    labLogo: { type: String, default: "lab-logo.png" },
    uestcLogo: { type: String, default: uestclogo },
    uestcSzLogo: { type: String, default: uestszclogo },
  },
  methods: {
    setDefaultLogo(event) {
      event.target.src = defaultLogo;
    },
  },
};
</script>

<style scoped>
/* header 样式保持原来就可以 */
header {
  background-color: #003366;
  color: #fff;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.lab-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.lab-logo {
  width: 60px;
  height: 60px;
  margin-right: 20px;
  background: #fff;
  border-radius: 5px;
}
.lab-title h1 {
  margin: 0;
  font-size: 1.8em;
}
.lab-title p {
  margin: 5px 0 0;
  font-size: 0.9em;
}

.sz-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.sz-logos {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}
.sz-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.sz-links {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}
.sz-link {
  color: #fff;
  text-decoration: none;
  font-size: 0.7em;
}
.sz-separator {
  color: rgba(255, 255, 255, 0.5);
}

.language-switcher {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 5px;
}
.language-btn {
  padding: 4px 8px;
  font-size: 0.5em;
  color: #fff;
  text-decoration: none;
  transition: 0.3s;
}
.language-btn.active {
  background: #fff;
  color: #003366;
}
.language-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
